import { render, staticRenderFns } from "./accountcenterPage.vue?vue&type=template&id=0606f609&scoped=true&"
import script from "./accountcenterPage.vue?vue&type=script&lang=js&"
export * from "./accountcenterPage.vue?vue&type=script&lang=js&"
import style0 from "./accountcenterPage.vue?vue&type=style&index=0&id=0606f609&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606f609",
  null
  
)

export default component.exports